import type { AnchorHTMLAttributes } from "react";
import { navigate } from "../lib/router";
import { navigateOnPlainClick } from "./NavTabs";

/**
 * An in-app link: a real `<a>` (hover URL, copy link, open in new tab) that
 * routes client-side on a plain click, like the nav tabs.
 */
export function AppLink({ href, children, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  return (
    <a href={href} onClick={navigateOnPlainClick(() => navigate(href))} {...rest}>
      {children}
    </a>
  );
}
